import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, InputNumber, Select, DatePicker } from 'antd';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import axios from 'axios';
const {Option} = Select
const LaborAddForm = ({ visible, onCreate, onCancel }) => {

  const [form] = Form.useForm();
  const [vehicleData, setVehicleData] = useState()
  const [employeeData, setEmployeeData] = useState()


  useEffect(()=>{
    //${FetchVariable.Heroku}
    let apiURL = `${FetchVariable.Heroku}/vehicle/`
      axios.get(apiURL)
      .then((res)=>{
        let data = res.data
        setVehicleData(data)
      })
    },[])
  
  useEffect(()=>{
    //${FetchVariable.Heroku}
    let apiURL = `${FetchVariable.Heroku}/employee/`
      axios.get(apiURL)
      .then((res)=>{
        let data = res.data
        setEmployeeData(data)
      })
    },[])

    function onChange(dateString) {
      form.setFieldsValue({
        PurchaseDate: dateString
      });
    }
  
    // const PurchaseDatePicker = () => {
  
    //   const dateFormat = "YYYY-MM-DD"
    //   return (
    //     <DatePicker
    //     onChange={onChange}
    //     format={dateFormat}
    //     style={{ width: '50%' }}
    //     />
    //   )
    // }

  return (
    <Modal
      visible={visible}
      title="Create a new collection"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}

    >
      <Form
        form={form}
        layout="vertical"
        name="LaborForm"
        initialValues={{
          LaborID:'',
          VehicleID:'',
          EmployeeID:'',
          LaborDate:'',
          LaborHours:0,
      }}
      >
        <Form.Item 
          name="VehicleID" label="Vehicle"
          rules={[{ required: true, message: 'Please select vehicle!' }]}
          >
          <Select>
            {vehicleData?.map(vehicle=><Option value={vehicle.VehicleID} key={vehicle.VehicleID}>Vehicle ID: {vehicle.VehicleID} - Vehicle VIN:{vehicle.VehicleVIN}</Option>)}
          </Select>        
        </Form.Item>
        <Form.Item
          name="EmployeeID"
          label="Employee"
          rules={[{ required: true, message: 'Please select Employee!' }]}
        >
          <Select 
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            showSearch>
            {employeeData?.map(employee=><Option value={employee.EmployeeID} key={employee.EmployeeID}>{employee.EmployeeName}</Option>)}
          </Select>   
        </Form.Item>
        <Form.Item
          name="LaborDate"
          label="Labor Date"
          rules={[{ required: true, message: 'Please select Labor Date!' }]}
        >
            {/* <PurchaseDatePicker />
             */}
                     <DatePicker
        onChange={onChange}
        format={'YYYY-MM-DD'}
        style={{ width: '50%' }}
        />
        </Form.Item>
        <Form.Item
          name="LaborHours"
          label="Labor Hours"
        >
              <InputNumber style={{ width: '50%' }} addonAfter="Hour" step='1'min="0"max="10"/>
        </Form.Item>
       
        
        
      </Form>
    </Modal>
  );
};

const LaborAdd = ( props ) => {
  const [visible, setVisible] = useState(false);

  const onCreate = (values) => {
    props.addLabor(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
      >
        Add New Labor
      </Button>
      <LaborAddForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </div>
  );
};

export default LaborAdd